import { ref, Ref } from "vue";

export interface PublicationStatus {
  publicationInProgress: boolean;
  startedBy: string | null;
  startedAt: string | null;
}

export const IDLE_PUBLICATION_STATUS: PublicationStatus = {
  publicationInProgress: false,
  startedBy: null,
  startedAt: null,
};

/**
 * Module-scoped publication status, shared by every consumer of the same appId
 * (banner, publish buttons, the axios interceptor). Kept in its own module so the
 * backend client can write to it without importing the polling hook (avoids an
 * import cycle: usePublicationStatus -> @/client -> usePublicationStatus).
 */
const statusByAppId = new Map<string, Ref<PublicationStatus>>();

export function getPublicationStatusRef(appId: string): Ref<PublicationStatus> {
  let status = statusByAppId.get(appId);
  if (!status) {
    status = ref({ ...IDLE_PUBLICATION_STATUS });
    statusByAppId.set(appId, status);
  }
  return status;
}

export function setPublicationStatus(appId: string, status: PublicationStatus) {
  getPublicationStatusRef(appId).value = status;
}

/**
 * Called by the backend client when a mutation is rejected with
 * Application.PublicationInProgress: reflects the lock immediately without
 * waiting for the next poll.
 */
export function markPublicationInProgress(
  appId: string,
  details: { startedBy?: string | null; startedAt?: string | null } = {}
) {
  setPublicationStatus(appId, {
    publicationInProgress: true,
    startedBy: details.startedBy ?? null,
    startedAt: details.startedAt ?? null,
  });
}
